import React from "react";
import { Container, Icons, Wrapper } from "./style";

const BlogCard = ({ value }) => {
  return (
    <Container>
      <Wrapper img="true">
        <Wrapper.Image src={value.img} />
      </Wrapper>
      <Wrapper main="true">
        <Wrapper icons="true">
          <Icons.User />
          <Wrapper.Title desc="true">{value.name}</Wrapper.Title>
          <Icons.Calendar />
          <Wrapper.Title desc="true">{value.date}</Wrapper.Title>
        </Wrapper>
        <Wrapper>
          <Wrapper.Title title="true" titleDesc="true">
            {value.title}
          </Wrapper.Title>
          <Wrapper.Title desc="true">{value.description}</Wrapper.Title>
        </Wrapper>
        <Wrapper info="true">{value.more}</Wrapper>
      </Wrapper>
    </Container>
  );
};
export default BlogCard;
